<template slot-scope="scope">
  <el-select
    :value="localValue"
    @input="$emit('input', $event)"
    placeholder="选择年级"
    clearable style="width: 100%">
    <el-option v-for="(item,index) in items" :key="index" :label="item.gradeName" :value="item.id"></el-option>
  </el-select>
</template>
<script>
  export default {
    props: {
      value: null,
      gradationId: {
        type: String,
        default: '',
      }
    },
    watch: {
      value(val){
        this.localValue = val
      },
      gradationId(){
        this.query();
      }
    },
    data() {
      return {
        localValue: this.value,
        items:[]
      }
    },
    methods: {
      query(){
        let vm = this
        if(!vm.gradationId) return
        http.get(InterfacePrefix['platform'] + "/api/grade?gradationId="+vm.gradationId+"&status=1").then(function(xhr) {
          if (xhr.data.code) return // 异常情况有公共处理
          vm.items = xhr.data
        })
      }
    },
    mounted() {
      this.query()
    },
  }

</script>



// WEBPACK FOOTER //
// src/commonplugin/chose_param/chooseGrade.vue